module.exports = __webpack_public_path__ + "static/media/mercurial.3ad5c23a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/mercurial.png
// module id = 145
// module chunks = 0